export default __webpack_public_path__ + "static/contact-us-bfbca0bd4b5032b4b7968eb7ed4afed6.png";